import * as React from 'react'

import { inject } from 'mobx-react'

import MobileCommonStore from '~/client/src/mobile/stores/ui/MobileCommon.store'
import Photo from '~/client/src/shared/models/Photo'

import './Photo.scss'

interface IProps {
  common?: MobileCommonStore
  photo: Photo
  width?: number
  height?: number
}

interface IState {
  isReady: boolean
}

@inject('common')
export default class PhotoView extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)
    this.state = {
      isReady: false,
    }
  }

  public render() {
    const { photo, width, height } = this.props
    return (
      <div
        className="photo-component indication-click"
        style={{
          width,
          height: this.state.isReady ? height : 0,
        }}
      >
        <img
          onClick={this.handleClick}
          src={photo.url}
          className="photo"
          onLoad={this.onLoad}
        />
      </div>
    )
  }

  private handleClick = () => {
    this.props.common.displayPhotoView(this.props.photo)
  }

  private onLoad = () => {
    this.setState({
      isReady: true,
    })
  }
}
